import React from 'react'
import { LoaderView } from '@vatom/wombo'
import { observer } from 'mobx-react-lite'
import { Flex, StatusBar } from 'native-base'

import { BottomHalf, TopHalf } from './partials'
import { useAuth } from './useAuth'

export const Connect = observer(() => {
  const { isLoading, tab, handleVatomLogin, walletSDKIsLoading, isEmbedded } = useAuth(undefined)

  if (isLoading || walletSDKIsLoading) {
    return <LoaderView />
  }

  if (isEmbedded) {
    return <LoaderView />
  }

  return (
    <Flex
      testID="LoginScreen"
      flexDirection="column"
      flex={1}
      bg="white"
      style={{ alignContent: 'center', justifyContent: 'center' }}
    >
      <StatusBar barStyle={tab.style} backgroundColor={tab.back} />
      <TopHalf />
      <BottomHalf onPressVatom={handleVatomLogin} />
    </Flex>
  )
})

export default Connect
